
import firebase from 'firebase/app'
import 'firebase/analytics'

class Analytics {
  logEvent = (eventString, params) => {
    if (process.env.NODE_ENV !== 'production') {
      return
    }

    firebase.analytics().logEvent(eventString, params)
  }

  setUserId = (idString) => {
    if (process.env.NODE_ENV !== 'production') {
      return
    }

    firebase.analytics().setUserId(idString)
  }

  setUserProperty = (user) => {
    if (process.env.NODE_ENV !== 'production') {
      return
    }
    const formatedUser = {}

    Object.keys(user).forEach(key => {
      const value = user[key]

      if (typeof value === 'string') {
        const trimmedValue = value.substring(0, 36)

        formatedUser[key] = trimmedValue
      } else {
        formatedUser[key] = `${value}`.substring(0, 36)
      }
    })

    firebase.analytics().setUserProperties(formatedUser)
  }
}

export default Analytics

